import { OrderModel } from "@app/interfaces/order";
import React from "react";
import ListImages from "../components/ListImages";

interface OrderInfoProps {
  record: OrderModel;
}

const OrderCompletedImages: React.FC<OrderInfoProps> = ({ record }) => {
  
  return (
    <ListImages
      record={record}
      assetType="completed"
      description="Hình ảnh sản phẩm thành phẩm"
    />
  )
}

export default OrderCompletedImages;